import React from 'react';
import {Card} from 'react-bootstrap';

const HelpCard = () => (
    <Card className="mb-4">
        <Card.Header>Besoin d&apos;aide ?</Card.Header>
        <Card.Body>
            <p className="mb-2">Notre équipe répond à vos questions :</p>
            <p className="mb-2"><strong>Email :</strong> <a href="mailto:Vertuo@astucetierspayant.fr">Vertuo@astucetierspayant.fr</a></p>
            <p className="mb-0"><strong>Horaires :</strong> lun - vend : 8h30 - 17h30</p>
        </Card.Body>
    </Card>
);

export default HelpCard;
